import React from 'react';
import "./BlogPost.css";

import pasko1 from '../../Assets/b62/pasko1.jpg';
import pasko2 from '../../Assets/b62/pasko2.jpg';
import pasko3 from '../../Assets/b62/pasko3.jpg';
import pasko4 from '../../Assets/b62/pasko4.jpg';
import pasko5 from '../../Assets/b62/pasko5.jpg';
import pasko6 from '../../Assets/b62/pasko6.jpg';

function Blog62(){
  return (
    <>
      <div className='container-fluid my-5'>
        <div className='row mb-5'>
          <div className='col blog-text text-center'>
            <h1>Team MYT celebrates the spirit of Christmas at Duyog sa Pasko</h1>
            <h6>December 04, 2025 at 10:34 AM</h6>
          </div>
        </div>

        <div className='row align-items-center justify-content-center mx-5 gx-5 gy-5'>
          <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-5 col-xxl-5'>
            <div id="blogImages" className="carousel slide mx-auto" data-bs-ride="true" data-bs-interval='3000'>
              <div className="carousel-indicators">
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="1" aria-label="Slide 2"></button>
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="2" aria-label="Slide 3"></button>
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="3" aria-label="Slide 4"></button>
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="4" aria-label="Slide 5"></button>
                <button type="button" data-bs-target="#blogImages" data-bs-slide-to="5" aria-label="Slide 6"></button>
              </div>
              <div className="carousel-inner">
                <div className="carousel-item active">
                  <img src={pasko1} className="blog-img" alt="..."/>
                </div>
                <div className="carousel-item">
                  <img src={pasko2} className="blog-img" alt="..."/>
                </div>
                <div className="carousel-item">
                  <img src={pasko3} className="blog-img" alt="..."/>
                </div>
                <div className="carousel-item">
                  <img src={pasko4} className="blog-img" alt="..."/>
                </div>
                <div className="carousel-item">
                  <img src={pasko5} className="blog-img" alt="..."/>
                </div>
                <div className="carousel-item">
                  <img src={pasko6} className="blog-img" alt="..."/>
                </div>
              </div>
              <button className="carousel-control-prev" type="button" data-bs-target="#blogImages" data-bs-slide="prev">
                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Previous</span>
              </button>
              <button className="carousel-control-next" type="button" data-bs-target="#blogImages" data-bs-slide="next">
                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                <span className="visually-hidden">Next</span>
              </button>
            </div>
          </div>
          <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 blog-text'>
            <p>Kagahapon ug Karon, featuring the UP Symphony Orchestra led by Maestro Chino Toledo,
                 held last December 02, 2025 at the Waterfront Grand Ballroom, Cebu City.</p>
            <p><a href='https://www.facebook.com/hashtag/myt' target='_blank' className='blog-link'>
              #MYT </a>
              <a href='https://www.facebook.com/hashtag/techforgood' target='_blank' className='blog-link'>
              #TechForGood </a>
              <a href='https://www.facebook.com/hashtag/buildtolast' target='_blank' className='blog-link'>
              #BuildToLast</a></p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Blog62;